import React from "react";

import {
  CHART_GRANULARITY_DAILY,
  CHART_GRANULARITY_WEEKLY,
} from "./chartsHelpers";

/**
 * Daily / Weekly segment control styled like other overview filter inputs.
 *
 * @param {Object} props
 * @param {"daily"|"weekly"} props.value - Active granularity.
 * @param {(value: "daily"|"weekly") => void} props.onChange - Selection handler.
 * @param {string} [props.label="Mode"] - Field label above the control.
 * @param {string} [props.ariaLabel="Chart time grouping"] - Accessible group name.
 * @returns {JSX.Element}
 */
const ChartGranularityToggle = ({
  value,
  onChange,
  label = "Mode",
  ariaLabel = "Chart time grouping",
}) => {
  const options = [
    { value: CHART_GRANULARITY_DAILY, label: "Daily" },
    { value: CHART_GRANULARITY_WEEKLY, label: "Weekly" },
  ];

  return (
    <div className="shrink-0">
      <div className="mb-1 text-xs font-medium font-inter text-gray-600">
        {label}
      </div>
      <div
        className="inline-flex h-[34px] items-stretch rounded-md border border-gray-300 bg-white p-0.5 shadow-sm"
        role="group"
        aria-label={ariaLabel}
      >
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              aria-pressed={isActive}
              className={`rounded px-2.5 text-sm font-medium transition ${
                isActive
                  ? "bg-gray-100 text-gray-900"
                  : "text-gray-500 hover:text-gray-800"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChartGranularityToggle;
